export default (num)=> +(Math.round(num + "e+2")  + "e-2");


// WEBPACK FOOTER //
// ./resources/assets/js/helpers/round.js